import type { cardApiSpec } from "@wingspanhq/wingspan-api-types";
import { cardsService } from "./cardsService";

export const closeCard = async (cardId: string): Promise<cardApiSpec.Card> => {
  const { data } = await cardsService.post(`/${cardId}/cancel`);

  return data;
};
